import styled from "styled-components";
import {
  DARK_GRAY,
  DARKER_GRAY,
  LIGHT_GRAY,
  RUBIK,
  WHITE,
} from "../../index.style.ts";

export const Wrapper = styled.div`
  background: ${WHITE};
  border: 1px solid ${LIGHT_GRAY};
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  h3 {
    margin: 0;
    font-family: ${RUBIK};
    font-size: 16px;
  }

  .total {
    font-size: 13px;
    color: ${DARK_GRAY};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px 140px 120px;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid ${LIGHT_GRAY};

  @media only screen and (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }

  .amount {
    font-family: ${RUBIK};
    color: ${DARKER_GRAY};
  }

  .muted {
    color: ${DARK_GRAY};
  }

  .actions {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
  }
`;

export const Empty = styled.div`
  font-size: 13px;
  color: ${DARK_GRAY};
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: ${DARK_GRAY};
  }

  input,
  select {
    font-family: inherit;
    font-size: 15px;
    padding: 8px 10px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 8px;
  }

  .row {
    display: flex;
    gap: 12px;

    label {
      flex: 1;
    }
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }

  .error {
    color: #ef5350;
    font-size: 13px;
  }
`;
